import React, { Component } from 'react';
import moment from 'moment';

import api from '../../../api/api';

import Modal from "./Modal"

import DateFilter from "../../../components/ParadigmaTable/DateFilter";
import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable"
import NumericFilter from "../../../components/ParadigmaTable/NumericFilter"
import { format } from '../../../functions/functions';


class HistorialMonedas extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'monedas_historial_detail',
                    },
                ]}
                columns={[
                    {
                        Header: "id",
                        id: "id",
                        accessor: "id",
                        width: 100,
                        private: true,
                        show: false,
                    },
                    {
                        Header: "Fecha Cotización",
                        id: "fecha_cotizacion",
                        accessor: d => moment(d.fecha_cotizacion).format('DD/MM/YYYY'),
                        className: "text-center",
                        width: 100,
                        Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />,
                        show: true,
                    },
                    {
                        Header: "Moneda",
                        id: "moneda_nombre",
                        accessor: d => d.moneda_nombre,
                        show: true,
                    },
                    {
                        Header: "Cotización (Pesos Argentinos)",
                        id: "cotizacion_pesos",
                        accessor: d => '$' + format(d.cotizacion_pesos),
                        Filter: ({ filter, onChange }) => <NumericFilter filter={filter} onChange={onChange}/>,
                        show: true,
                    },
                ]}
                apiUrl={api.monedas.historial}
                exportUrl={api.monedas.historial}
                title={"Historial de Cotizaciones"}
            />
        );
    }
}

export default HistorialMonedas;



// WEBPACK FOOTER //
// ./src/views/Monedas/Historial/HistorialMonedas.js